import { toast } from "react-toastify";
import { CourseAPI } from "../constants/apiRoutes";
import { courseActions } from "../reducers/course";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const createNewCourse = (data, navigate) => {
  return async (dispatch) => {
    dispatch(courseActions.actionStart());
    try {
      await apiService.post(CourseAPI.create(), data);
      dispatch(courseActions.actionSuccess("create"));
    } catch (err) {
      dispatch(courseActions.clearError());
      handleError(err);
    }
  };
};

export const updateCourse = (data, navigate, id) => {
  return (dispatch) => {
    dispatch(courseActions.actionStart());
    return apiService
      .put(CourseAPI.update(id), data)
      .then((response) => {
        dispatch(courseActions.actionSuccess("update"));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const deleteCourse = (id) => {
  return (dispatch) => {
    return apiService
      .delete(CourseAPI.delete(id))
      .then((response) => {
        toast.success("Uspešno ste obrisali kurs", {
          theme: "colored",
        });

        dispatch(fetchCourseList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCourseList = () => {
  return (dispatch) => {
    return apiService
      .get(CourseAPI.list())
      .then((response) => {
        dispatch(courseActions.fetchCourseList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCourseFormList = (val = null) => {
  return (dispatch) => {
    return apiService
      .get(CourseAPI.form(val))
      .then((response) => {
        dispatch(courseActions.fetchCourseFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCourseById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(CourseAPI.getById(id))
      .then((response) => {
        dispatch(courseActions.fetchCourseDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCourseFormListClear = (val) => {
  return (dispatch) => {
    dispatch(courseActions.fetchCourseFormListClear());
  };
};
